/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccessPermission } from '../../models/access-permission';
import { FileManagerDirectoryContent } from '../../models/file-manager-directory-content';

export interface ApiFileManagerGetImageGet$Params {
  Path?: string;
  Action?: string;
  NewName?: string;
  Names?: Array<string>;
  Name?: string;
  Size?: number;
  PreviousName?: string;
  DateModified?: string;
  DateCreated?: string;
  HasChild?: boolean;
  IsFile?: boolean;
  Type?: string;
  Id?: string;
  FilterPath?: string;
  FilterId?: string;
  ParentId?: string;
  TargetPath?: string;
  RenameFiles?: Array<string>;
  CaseSensitive?: boolean;
  SearchString?: string;
  ShowHiddenItems?: boolean;
  Data?: Array<FileManagerDirectoryContent>;
  'TargetData.Path'?: string;
  'TargetData.Action'?: string;
  'TargetData.NewName'?: string;
  'TargetData.Names'?: Array<string>;
  'TargetData.Name'?: string;
  'TargetData.Size'?: number;
  'TargetData.PreviousName'?: string;
  'TargetData.DateModified'?: string;
  'TargetData.DateCreated'?: string;
  'TargetData.HasChild'?: boolean;
  'TargetData.IsFile'?: boolean;
  'TargetData.Type'?: string;
  'TargetData.Id'?: string;
  'TargetData.FilterPath'?: string;
  'TargetData.FilterId'?: string;
  'TargetData.ParentId'?: string;
  'TargetData.TargetPath'?: string;
  'TargetData.RenameFiles'?: Array<string>;
  'TargetData.CaseSensitive'?: boolean;
  'TargetData.SearchString'?: string;
  'TargetData.ShowHiddenItems'?: boolean;
  'TargetData.Data'?: Array<FileManagerDirectoryContent>;
  'TargetData.TargetData.Path'?: string;
  'TargetData.TargetData.Action'?: string;
  'TargetData.TargetData.NewName'?: string;
  'TargetData.TargetData.Names'?: Array<string>;
  'TargetData.TargetData.Name'?: string;
  'TargetData.TargetData.Size'?: number;
  'TargetData.TargetData.PreviousName'?: string;
  'TargetData.TargetData.DateModified'?: string;
  'TargetData.TargetData.DateCreated'?: string;
  'TargetData.TargetData.HasChild'?: boolean;
  'TargetData.TargetData.IsFile'?: boolean;
  'TargetData.TargetData.Type'?: string;
  'TargetData.TargetData.Id'?: string;
  'TargetData.TargetData.FilterPath'?: string;
  'TargetData.TargetData.FilterId'?: string;
  'TargetData.TargetData.ParentId'?: string;
  'TargetData.TargetData.TargetPath'?: string;
  'TargetData.TargetData.RenameFiles'?: Array<string>;
  'TargetData.TargetData.CaseSensitive'?: boolean;
  'TargetData.TargetData.SearchString'?: string;
  'TargetData.TargetData.ShowHiddenItems'?: boolean;
  'TargetData.TargetData.Data'?: Array<FileManagerDirectoryContent>;
  'TargetData.TargetData.TargetData'?: FileManagerDirectoryContent;
  'TargetData.TargetData.Permission'?: AccessPermission;
  'TargetData.Permission'?: AccessPermission;
  Permission?: AccessPermission;
      body?: {
'UploadFiles'?: Array<Blob>;
'TargetData.UploadFiles'?: Array<Blob>;
'TargetData.TargetData.UploadFiles'?: Array<Blob>;
}
}

export function apiFileManagerGetImageGet(http: HttpClient, rootUrl: string, params?: ApiFileManagerGetImageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiFileManagerGetImageGet.PATH, 'get');
  if (params) {
    rb.query('Path', params.Path, {});
    rb.query('Action', params.Action, {});
    rb.query('NewName', params.NewName, {});
    rb.query('Names', params.Names, {});
    rb.query('Name', params.Name, {});
    rb.query('Size', params.Size, {});
    rb.query('PreviousName', params.PreviousName, {});
    rb.query('DateModified', params.DateModified, {});
    rb.query('DateCreated', params.DateCreated, {});
    rb.query('HasChild', params.HasChild, {});
    rb.query('IsFile', params.IsFile, {});
    rb.query('Type', params.Type, {});
    rb.query('Id', params.Id, {});
    rb.query('FilterPath', params.FilterPath, {});
    rb.query('FilterId', params.FilterId, {});
    rb.query('ParentId', params.ParentId, {});
    rb.query('TargetPath', params.TargetPath, {});
    rb.query('RenameFiles', params.RenameFiles, {});
    rb.query('CaseSensitive', params.CaseSensitive, {});
    rb.query('SearchString', params.SearchString, {});
    rb.query('ShowHiddenItems', params.ShowHiddenItems, {});
    rb.query('Data', params.Data, {});
    rb.query('TargetData.Path', params['TargetData.Path'], {});
    rb.query('TargetData.Action', params['TargetData.Action'], {});
    rb.query('TargetData.NewName', params['TargetData.NewName'], {});
    rb.query('TargetData.Names', params['TargetData.Names'], {});
    rb.query('TargetData.Name', params['TargetData.Name'], {});
    rb.query('TargetData.Size', params['TargetData.Size'], {});
    rb.query('TargetData.PreviousName', params['TargetData.PreviousName'], {});
    rb.query('TargetData.DateModified', params['TargetData.DateModified'], {});
    rb.query('TargetData.DateCreated', params['TargetData.DateCreated'], {});
    rb.query('TargetData.HasChild', params['TargetData.HasChild'], {});
    rb.query('TargetData.IsFile', params['TargetData.IsFile'], {});
    rb.query('TargetData.Type', params['TargetData.Type'], {});
    rb.query('TargetData.Id', params['TargetData.Id'], {});
    rb.query('TargetData.FilterPath', params['TargetData.FilterPath'], {});
    rb.query('TargetData.FilterId', params['TargetData.FilterId'], {});
    rb.query('TargetData.ParentId', params['TargetData.ParentId'], {});
    rb.query('TargetData.TargetPath', params['TargetData.TargetPath'], {});
    rb.query('TargetData.RenameFiles', params['TargetData.RenameFiles'], {});
    rb.query('TargetData.CaseSensitive', params['TargetData.CaseSensitive'], {});
    rb.query('TargetData.SearchString', params['TargetData.SearchString'], {});
    rb.query('TargetData.ShowHiddenItems', params['TargetData.ShowHiddenItems'], {});
    rb.query('TargetData.Data', params['TargetData.Data'], {});
    rb.query('TargetData.TargetData.Path', params['TargetData.TargetData.Path'], {});
    rb.query('TargetData.TargetData.Action', params['TargetData.TargetData.Action'], {});
    rb.query('TargetData.TargetData.NewName', params['TargetData.TargetData.NewName'], {});
    rb.query('TargetData.TargetData.Names', params['TargetData.TargetData.Names'], {});
    rb.query('TargetData.TargetData.Name', params['TargetData.TargetData.Name'], {});
    rb.query('TargetData.TargetData.Size', params['TargetData.TargetData.Size'], {});
    rb.query('TargetData.TargetData.PreviousName', params['TargetData.TargetData.PreviousName'], {});
    rb.query('TargetData.TargetData.DateModified', params['TargetData.TargetData.DateModified'], {});
    rb.query('TargetData.TargetData.DateCreated', params['TargetData.TargetData.DateCreated'], {});
    rb.query('TargetData.TargetData.HasChild', params['TargetData.TargetData.HasChild'], {});
    rb.query('TargetData.TargetData.IsFile', params['TargetData.TargetData.IsFile'], {});
    rb.query('TargetData.TargetData.Type', params['TargetData.TargetData.Type'], {});
    rb.query('TargetData.TargetData.Id', params['TargetData.TargetData.Id'], {});
    rb.query('TargetData.TargetData.FilterPath', params['TargetData.TargetData.FilterPath'], {});
    rb.query('TargetData.TargetData.FilterId', params['TargetData.TargetData.FilterId'], {});
    rb.query('TargetData.TargetData.ParentId', params['TargetData.TargetData.ParentId'], {});
    rb.query('TargetData.TargetData.TargetPath', params['TargetData.TargetData.TargetPath'], {});
    rb.query('TargetData.TargetData.RenameFiles', params['TargetData.TargetData.RenameFiles'], {});
    rb.query('TargetData.TargetData.CaseSensitive', params['TargetData.TargetData.CaseSensitive'], {});
    rb.query('TargetData.TargetData.SearchString', params['TargetData.TargetData.SearchString'], {});
    rb.query('TargetData.TargetData.ShowHiddenItems', params['TargetData.TargetData.ShowHiddenItems'], {});
    rb.query('TargetData.TargetData.Data', params['TargetData.TargetData.Data'], {});
    rb.query('TargetData.TargetData.TargetData', params['TargetData.TargetData.TargetData'], {});
    rb.query('TargetData.TargetData.Permission', params['TargetData.TargetData.Permission'], {});
    rb.query('TargetData.Permission', params['TargetData.Permission'], {});
    rb.query('Permission', params.Permission, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiFileManagerGetImageGet.PATH = '/api/FileManager/GetImage';
